@if (vm$ | async; as vm) {
  <div class="addressV2" [class.addressV2--desktop]="context === ControlContext.Desktop">
    @if ((manualEdit$ | async) === false) {
      <jump-tech-frontend-address-search
        [provider]="provider"
        [context]="context"
        [selectedAddress]="address"
        [disabled]="disabled"
        [errorMessage]="errorMessage"
        [required]="required"
        [countryCodes]="vm.countryCodes"
        [label]="vm.label"
        [placeholder]="placeholder"
        (selectedResult)="addressSelected($event)"
      ></jump-tech-frontend-address-search>
    }
    <div class="addressV2__results">
      @if (address && (manualEdit$ | async) === false) {
        <jump-tech-frontend-address-result
          class="addressV2__results__result"
          [address]="address"
          [context]="context"
          [countryCodes]="vm.countryCodes"
        ></jump-tech-frontend-address-result>
      }
      @if (manualEdit$ | async) {
        <jump-tech-frontend-address-editor
          class="addressV2__results__editor"
          [context]="context"
          [selectedAddress]="address"
          [countryCodes]="vm.countryCodes"
          (addressUpdated)="addressUpdatedManually($event)"
        ></jump-tech-frontend-address-editor>
      }
    </div>
    @if (allowManualEntry) {
      @if ((manualEdit$ | async) === false && !disabled) {
        <span
          class="addressV2__manual-toggle"
          size="sm"
          [attr.data-qa]="'addressInputToggle'"
          (click)="toggleEditAddress()"
          >
          {{ vm.enterManually }}
        </span>
      }
    }
  </div>
}
